import { useFormContext, useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { isEmpty, isString } from 'lodash-es'
import { useMemo } from 'react'

import { filterEnabledMemberships } from '../../helpers'
import { filterByPoolUid, getUserPoolUid, withoutDeleted } from '../helpers'

export const useHostsListData = (userPool, isTeam = false) => {
  const formPath = `userPools[${userPool?.position}].name`
  const [_, { error: nameError }] = useFormField({ name: formPath })
  const {
    values: { memberships },
    errors: { memberships: membershipsError, userPools: userPoolsError },
  } = useFormContext()

  const userPoolUid = getUserPoolUid(userPool)
  const currentMemberships = useMemo(() => withoutDeleted(memberships), [memberships])

  const members = useMemo(() => (
    userPoolUid ? filterByPoolUid(currentMemberships, userPoolUid) : currentMemberships
  ), [currentMemberships, userPoolUid])

  // TODO:
  //  figure out why we have this jest test 'should not display if the user is disabled'
  //  it should be (isTeam ? filterEnabledMemberships(members) : members)
  const hosts = useMemo(() => filterEnabledMemberships(members), [members])

  const isHostsEmpty = isEmpty(hosts)
  const isLastHost = hosts.length === 1
  const userPoolError = Array.isArray(userPoolsError) ? userPoolsError[userPool?.position] : userPoolsError
  const isAllUserPoolsError = userPoolError && isString(userPoolError)

  const noHostsErrorMessage = isTeam
    ? I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.errors.no_hosts')
    : I18n.t('publisher.event_type_editor.sections.hosts.errors.no_hosts')

  return {
    userPoolUid,
    formPath,
    isHostsEmpty,
    isLastHost,
    hosts,
    nameError,
    hasError: !!membershipsError || isAllUserPoolsError || isHostsEmpty,
    errorMessage: membershipsError || (isAllUserPoolsError && userPoolError) || (isHostsEmpty && noHostsErrorMessage)
  }
}
